import React, { useState } from 'react'

import FormBlock from 'components/Forms/FormBlock'
import FormModal from 'components/Modal/FormModal/FormModal'
import Toast, { TOAST_TYPE } from 'components/Toast/Toast'
import Input from 'components/Forms/Input/Input'
import Select from 'components/Forms/Select/Select'

import { fieldsValidator, getIsNotEmptyStringRule, getIsValueRule, getIsNotIncludeInArray } from 'utils/fieldsValidator'
import { removeKeyFromObject } from 'utils/common'

const AddCountryCurrencyModal = ({ currencies, countryCodes, onSubmit, onClose }) => {
    const [countryCode, setCountryCode] = useState('')
    const [currency, setCurrency] = useState(null)

    const [errors, setErrors] = useState({})

    const handleSubmit = async () => {
        try {
            setErrors({})

            const validator = new fieldsValidator()

            validator.addFields([
                validator.createField('countryCode', countryCode, [
                    getIsValueRule(),
                    getIsNotEmptyStringRule(),
                    getIsNotIncludeInArray(countryCodes, `Country code "${countryCode}" already exist`),
                ]),
                validator.createField('currency', currency, [getIsValueRule()]),
            ])

            const { isHasErrors, errors } = validator.validate()
            if (isHasErrors) {
                setErrors(errors)
                return
            }

            await onSubmit({ countryCode, currency: currency.value })

            return true
        } catch (err) {
            console.error(err)
            Toast(TOAST_TYPE.ERROR)
            throw err
        }
    }

    return (
        <FormModal
            headText="Add country currency"
            successText="Country currency added successfully!"
            actionText="Accept"
            onAction={() => handleSubmit()}
            onClose={() => onClose()}
        >
            <FormBlock label="Country code">
                <Input
                    value={countryCode}
                    error={errors.countryCode}
                    onChange={value => {
                        setCountryCode(value)
                        setErrors(removeKeyFromObject(errors, 'countryCode'))
                    }}
                />
            </FormBlock>
            <FormBlock label="New currency">
                <Select
                    value={currency}
                    error={errors.currency}
                    options={currencies.map(item => ({
                        value: item.currency,
                        label: `${item.currency} (${item.symbol})`,
                        payload: item,
                    }))}
                    onChange={value => {
                        setCurrency(value)
                        setErrors(removeKeyFromObject(errors, 'currency'))
                    }}
                />
            </FormBlock>
        </FormModal>
    )
}

export default AddCountryCurrencyModal
